import { Routes as AppRoutes } from "@/constants/routes";

const funnelApplovinRoutes = [AppRoutes.BodyScanPlansApplovin, AppRoutes.SeniorsApplovin];

export const getIsFunnelApplovin = () => {
    const pathnamesArray = window.location.pathname.split("/");

    return funnelApplovinRoutes.some((route) => pathnamesArray.includes(route));
};
